// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-lending-vaf-cmb-v2/form-item-business-lending-vaf-cmb-v2.component.scss
// module id = 606
// module chunks = 0